import React from 'react';

import { ScrollMenu } from 'react-horizontal-scrolling-menu';
import { LeftArrow, RightArrow } from './Arrows';
import RecentCard from './RecentCard';
import { Icon, Loading } from 'js/components';
import { faSpiderWeb } from '@fortawesome/pro-thin-svg-icons';

function RecentList({
  recentAssessments,
  recentAssessmentsIsLoading,
  recentAssessmentsHaveLoaded,
  onSelect = () => {},
  s,
}) {
  switch (true) {
    case !recentAssessmentsHaveLoaded && recentAssessmentsIsLoading:
      return (
        <div className="media text-muted">
          <Loading style={{ fontSize: '4rem' }} />
        </div>
      );
    case recentAssessmentsHaveLoaded && recentAssessments.length === 0:
      return (
        <div className="media text-muted">
          <Icon icon={faSpiderWeb} size="4x" className="mr-3" fixedWidth />
          <div className="media-body">
            <div>You haven't run any assessments yet.</div>
          </div>
        </div>
      );
    default:
      return (
        <ScrollMenu LeftArrow={LeftArrow} RightArrow={RightArrow}>
          {recentAssessments.map((assessment) => (
            <RecentCard
              key={assessment.id}
              assessment={assessment}
              onClick={onSelect}
            />
          ))}
        </ScrollMenu>
      );
  }
}

export default RecentList;
